export enum WizardStep {
    PRIMARY_VEHICLE_YEAR = 1,
    PRIMARY_VEHICLE_MAKE,
    PRIMARY_VEHICLE_MODEL,
    ADD_SECOND_VEHICLE,
    SECONDARY_VEHICLE_YEAR,
    SECONDARY_VEHICLE_MAKE,
    SECONDARY_VEHICLE_MODEL,
    INSURANCE_CARRIER,
    INSURED_SINCE,
    GENDER,
    CREDIT_HISTORY,
    LICENSE_STATUS,
    FILING_REQUIRED,
    INCIDENTS,
    MARITAL_STATUS,
    IS_MILITARY,
    HOMEOWNER,
    HOME_ADDON_BUNDLE,
    HOME_ADDON_YEAR_BUILT,
    HOME_ADDON_PROPERTY_TYPE,
    HOME_ADDON_ANY_CLAIMS,
    HOME_ADDON_INTERESTED_IN_FLOOD_INSURANCE,
    BIRTH_YEAR,
    BIRTH_MONTH,
    BIRTH_DAY,
    CONTACT_INFO_NAME,
    ADDITIONAL_DRIVER,
    ADDITIONAL_DRIVER_BIRTH_YEAR,
    ADDITIONAL_DRIVER_BIRTH_MONTH,
    ADDITIONAL_DRIVER_BIRTH_DAY,
    ADDITIONAL_DRIVER_NAME,
    CONTACT_INFO_ADDRESS,
    PRE_FILLED_QUOTE,
    AGE,
    PET_INSURANCE
}